import { Lock } from "lucide-react";

import useTranslations from "@/shared/lang/useTranslations";

/** "Verificación segura y cifrada por Coloca" — never names the provider. */
export function TrustFooter() {
  const { t } = useTranslations("verification");
  return (
    <div className="flex items-center justify-center gap-1.5 px-4 py-4 text-xs text-muted-foreground">
      <Lock className="size-3.5 shrink-0" aria-hidden="true" />
      <span>{t("trust_footer")}</span>
    </div>
  );
}
